import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RivolutionLoginResult } from '../../models/rivolution-login-result.model';

interface XsrfTokenResponse {
    xsrfToken: string;
}

@Injectable({ providedIn: 'root' })
export class AuthProxyService {
    private baseUrl = `${environment.API_URL}/Rivolution`;

    constructor(private http: HttpClient) {}

    login(username: string, password: string): Observable<string> {
        const params = new HttpParams()
            .set('Username', username)
            .set('Password', password);
        return this.http.post(`${this.baseUrl}/Login`, null, { params, responseType: 'text' }).pipe(
            map(token => token.replace(/^"|"$/g, ''))
        );
    }

    inspectorPortalLogin(username: string, password: string): Observable<RivolutionLoginResult> {
        return this.http.post<RivolutionLoginResult>(`${this.baseUrl}/InspectorPortalLogin`, { Username: username, Password: password });
    }

    vehicleImportFormLogin(username: string, password: string): Observable<RivolutionLoginResult> {
        return this.http.post<RivolutionLoginResult>(`${this.baseUrl}/VehicleImportFormLogin`, { Username: username, Password: password });
    }

    logout(token: string): Observable<void> {
        const params = new HttpParams().set('Token', token);
        return this.http.get<void>(`${this.baseUrl}/Logout`, { params });
    }

    tick(token: string): Observable<boolean> {
        const params = new HttpParams().set('token', token);
        return this.http.post<boolean>(`${this.baseUrl}/Tick`, null, { params });
    }

    getXsrfToken(): Observable<string> {
        return this.http.get<XsrfTokenResponse>(`${this.baseUrl}/GetXsrfToken`).pipe(
            map(response => response.xsrfToken)
        );
    }

    checkPermission(token: string, permissionName: string): Observable<boolean> {
        const params = new HttpParams().set('token', token).set('permissionName', permissionName);
        return this.http.get<boolean>(`${this.baseUrl}/CheckPermission`, { params });
    }

    getInspectorByToken(token: string): Observable<any> {
        const params = new HttpParams().set('token', token);
        return this.http.get(`${this.baseUrl}/GetInspectorByToken`, { params });
    }
}
